export default __webpack_public_path__ + "static/media/other21.c8e4a0b6.webp";